import {IContestant} from "../typings/IContestant";
import {Model} from "./Model";
import {IApiTeam} from "../typings/apiResponse";

export interface ITeam extends IContestant {
    getSuffix(): string;
    getPrefix(): string;
    getArea(): string;
    isPublic(): boolean;
    getPassword(): string;
    getMemberCount(): number;
}

export interface ITeamEditableFields {
    name?: string;
    suffix?: string;
    prefix?: string;
    region?: string;
    area?: string;
    homepage?: string;
    isPublic?: boolean;
    password?: string;
}

export class Team extends Model implements ITeam {

    constructor(private apiData: IApiTeam) {
        super(apiData);
    }

    public getId():string {
        return this.apiData.id;
    }

    public getName():string {
        return this.apiData.name;
    }

    public getFullName():string {
        return (this.apiData.prefix ? this.apiData.prefix + '.' : '') + this.apiData.name + (this.apiData.suffix ? '.' + this.apiData.suffix : '');
    }

    public getSuffix():string {
        return this.apiData.suffix;
    }

    public getPrefix():string {
        return this.apiData.prefix;
    }

    public getRegion():string {
        return this.apiData.region;
    }

    public getArea():string {
        return this.apiData.area;
    }

    public getHomepage():string {
        return this.apiData.homepage;
    }

    public getPhoto():string {
        return this.apiData.logo;
    }

    public getPremium(): boolean {
        return this.apiData.premium;
    }

    public getTrustLevel(): number {
        return this.apiData.trustLevel;
    }

    public getPenaltyPoints():number {
        if (typeof this.apiData.penaltyPoints !== 'undefined') {
            return this.apiData.penaltyPoints;
        }

        return 0;
    }

    public isBarred():boolean {
        return this.apiData.isBarred;
    }

    public isPublic():boolean {
        return this.apiData.isPublic;
    }

    public getPassword():string {
        return this.apiData.password;
    }

    public getMemberCount():number {
        return this.apiData.memberCount;
    }
}
